module.exports = __webpack_public_path__ + "static/media/p3.82503048.png";